import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const commonapi = createApi({
    reducerPath: "commonapi",
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({

        getAllStudentRegistrationDropdown: builder.query({
            query: () => ({
                url: "/util/student/dropdown",
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getInstitutes: builder.query({
            query: ({ page = 0, size = 10, search = '', universityId } = {}) => ({
                url: "/util/student/dropdown/institute",
                method: 'GET',
                params: {
                    page,
                    size,
                    ...(search ? { search } : {}),
                    ...(universityId ? { universityId } : {}),
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
         getUniversities: builder.query({
            query: ({ page = 0, size = 10, search = '', universityId } = {}) => ({
                url: "/util/student/dropdown/university",
                method: 'GET',
                params: {
                    page,
                    size,
                    ...(search ? { search } : {}),
                    ...(universityId ? { universityId } : {}),
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getLandingPageJobsInternships: builder.query({
            query: ({ page = 0, size = 10 } = {}) => ({
                url: "/util/landing-page/jobs-internships",
                method: 'GET',
                params: { page, size },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useLazyGetAllStudentRegistrationDropdownQuery,
    useLazyGetInstitutesQuery,
    useLazyGetUniversitiesQuery,
    useGetLandingPageJobsInternshipsQuery
} = commonapi;

export default commonapi;
